// extracted by mini-css-extract-plugin
export default {"travelIcon":"CzvDnyiUoGVhI6YqwrDQKA=="};